
import { defineComponent, ref } from "vue";
import { imageUrlBuilder } from "@/services/sanity";
import Label from "@moonlight/vue3/components/Label.vue";

export default defineComponent({
  components: {
    Label,
  },
  props: {
    image: { type: String, required: true },
    title: { type: String, default: "" },
    type: { type: String, required: false },
  },
  setup() {
    const isImageLoaded = ref(false);
    return {
      imageUrlBuilder,
      isImageLoaded,
    };
  },
  computed: {
    src: function () {
      return this.imageUrlBuilder
        .image(this.image)
        .width(480)
        .auto("format")
        .url();
    },
    srcset: function () {
      const img = this.imageUrlBuilder.image(this.image);
      return `
        ${img.width(240).auto("format").url()} 240w,
        ${img.width(480).auto("format").url()} 480w, 
        ${img.width(720).auto("format").url()} 720w
      `;
    },
  },
});
